import api from "../../shared/api";

export default {
  state: () => ({
    list: [],
  }),
  actions: {
    getLimitTypes({ state }, data) {
      api.get(
        "all/limit-types",
        (result) => {
          state.list = result.data.items;
          if (data && data.onSuccess) data.onSuccess(result);
        },
        (error) => {
          if (data && data.onError) data.onError(error);
        },
        () => {
          if (data && data.onFinish) data.onFinish();
        }
      );
    },
  },
};
